import { render, staticRenderFns } from "./DragMenuList.vue?vue&type=template&id=df1e2618"
import script from "./DragMenuList.vue?vue&type=script&lang=js"
export * from "./DragMenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports